// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: var(--ui-gap-xs, 4px);
}

.pager__page,
.pager__step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 var(--ui-gap-sm, 8px);
  border: 1px solid var(--ui-border, rgba(15, 23, 42, 0.1));
  border-radius: var(--ui-radius-sm, 8px);
  background: var(--ui-surface, #ffffff);
  color: var(--ion-color-dark, #1f2937);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background var(--ui-transition, 0.15s ease), border-color var(--ui-transition, 0.15s ease);
}
.pager__page:disabled,
.pager__step:disabled {
  color: var(--ui-text-muted, #6b7280);
  cursor: default;
  opacity: 0.5;
}
.pager__page ion-icon,
.pager__step ion-icon {
  font-size: 16px;
}

.pager__page--current {
  border-color: var(--ion-color-primary);
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast, #ffffff);
  font-weight: 600;
}
.pager__page--current:hover:not(.disabled) {
  color: var(--label-color, var(--ion-color-primary));
}

.pager__gap {
  padding: 0 var(--ui-gap-xs, 4px);
  color: var(--ui-text-muted, #6b7280);
}

.pager__page:hover:not(.disabled) {
  background: var(--ion-color-primary-tint, #f4f5f8);
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/pager/pager.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;AAAF;;AAGA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,yDAAA;EACA,uCAAA;EACA,sCAAA;EACA,qCAAA;EAEA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sGAAA;AADF;AAIE;;EACE,oCAAA;EACA,eAAA;EACA,YAAA;AADJ;AAIE;;EACE,eAAA;AADJ;;AAKA;EACE,sCAAA;EACA,oCAAA;EACA,iDAAA;EACA,gBAAA;AAFF;AAIE;EACE,mDAAA;AAFJ;;AAMA;EACE,gCAAA;EACA,oCAAA;AAHF;;AAMA;EACM,kDAAA;AAHN","sourcesContent":["// Same look as the pager of the paged lists; the variables fall back for themes without them\n:host {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--ui-gap-xs, 4px);\n}\n\n.pager__page,\n.pager__step {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 34px;\n  height: 34px;\n  padding: 0 var(--ui-gap-sm, 8px);\n  border: 1px solid var(--ui-border, rgba(15, 23, 42, 0.1));\n  border-radius: var(--ui-radius-sm, 8px);\n  background: var(--ui-surface, #ffffff);\n  color: var(--ion-color-dark, #1f2937);\n\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background var(--ui-transition, 0.15s ease),\n    border-color var(--ui-transition, 0.15s ease);\n\n  &:disabled {\n    color: var(--ui-text-muted, #6b7280);\n    cursor: default;\n    opacity: 0.5;\n  }\n\n  ion-icon {\n    font-size: 16px;\n  }\n}\n\n.pager__page--current {\n  border-color: var(--ion-color-primary);\n  background: var(--ion-color-primary);\n  color: var(--ion-color-primary-contrast, #ffffff);\n  font-weight: 600;\n\n  &:hover:not(.disabled) {\n    color: var(--label-color, var(--ion-color-primary));\n  }\n}\n\n.pager__gap {\n  padding: 0 var(--ui-gap-xs, 4px);\n  color: var(--ui-text-muted, #6b7280);\n}\n\n.pager__page:hover:not(.disabled) {\n      background: var(--ion-color-primary-tint, #f4f5f8);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
